module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-down-circle-d77ecc180895dd94597ba97f96de32c9.svg";